import { useTranslations } from "use-intl";

/**
 * Renders a visually hidden link that becomes visible on keyboard focus.
 * Allows keyboard-only users to jump past the navigation shell directly
 * into the page's main content region (id="main-content").
 */
export function SkipLink() {
  const t = useTranslations("a11y");
  return (
    <a href="#main-content" className="skip-link">
      {t("skip_to_main")}
    </a>
  );
}
